import dynamic from "next/dynamic";
const BlogCardsGridComponent = dynamic(()=>import("./blog-cards-grid-component"));
import BlogCardsGridConfig from "./blog-cards-grid-config";
import BlogCardsGridAdvancedConfig from "./blog-cards-grid-advanced-config";
export default {
    BlogCardsGridComponent,
    BlogCardsGridConfig,
    BlogCardsGridAdvancedConfig
};
